const FiltresPlantes = ({ annonces, filters, onChange }) => {
  const uniqueTypePlante = [
    ...new Set(annonces.map((a) => a.typePlante).filter(Boolean)),
  ];

  return (
    <>
      <div>
        <h3>Type de plante</h3>
        {uniqueTypePlante.map((type) => (
          <label key={type}>
            <input
              type="checkbox"
              name="typePlante"
              value={type}
              onChange={onChange}
            />
            {type}
          </label>
        ))}
      </div>

      <div>
        <h3>Prix</h3>
        <label>
          Min:
          <input
            type="number"
            name="prixMin"
            value={filters.prixMin}
            onChange={onChange}
            placeholder="Prix minimum"
          />
        </label>
        <label>
          Max:
          <input
            type="number"
            name="prixMax"
            value={filters.prixMax}
            onChange={onChange}
            placeholder="Prix maximum"
          />
        </label>
      </div>
    </>
  );
};

export default FiltresPlantes;
